import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { artistUser } from "../data/data";
import { LinkIcon } from "./LinkIcon";
import { CommissionForm } from "./CommissionForm";

export default function Contact() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#commission") {
      const el = document.getElementById("commission");
      if (el) {
        window.setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location.hash, location.search]);

  return (
    <main>
      <section className="section-container py-12 sm:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium uppercase tracking-[0.15em] text-accent">
            {t("contact.eyebrow")}
          </p>
          <h1 className="mt-2 font-display text-4xl font-semibold text-canvas-950 sm:text-5xl">
            {t("contact.title")}
          </h1>
          <p className="mt-4 text-lg leading-relaxed text-canvas-600">
            {t("contact.description")}
          </p>
        </div>

        <div
          id="commission"
          className="mx-auto mt-10 max-w-md scroll-mt-24 art-card p-6 sm:p-8"
        >
          <div className="mb-6 text-center">
            <h2 className="font-display text-2xl font-semibold text-canvas-950">
              {t("contact.commissionTitle")}
            </h2>
            <p className="mt-2 text-sm text-canvas-600">
              {t("contact.commissionSubtitle")}
            </p>
          </div>
          <CommissionForm />
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl gap-6 sm:grid-cols-2">
          <a
            href={`mailto:${t("common.email")}`}
            className="art-card flex flex-col items-center p-8 text-center transition-transform hover:scale-[1.02]"
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent/10 text-accent">
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
                aria-hidden
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                />
              </svg>
            </div>
            <h2 className="mt-4 font-display text-xl font-medium text-canvas-950">
              {t("contact.emailTitle")}
            </h2>
            <p className="mt-2 text-sm text-canvas-600">{t("common.email")}</p>
            <span className="btn-primary mt-4 !px-5 !py-2 !text-xs">
              {t("contact.sendEmail")}
            </span>
          </a>

          <div className="art-card flex flex-col items-center p-8 text-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-canvas-200/60 text-canvas-700">
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
                aria-hidden
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                />
              </svg>
            </div>
            <h2 className="mt-4 font-display text-xl font-medium text-canvas-950">
              {t("contact.followTitle")}
            </h2>
            <p className="mt-2 text-sm text-canvas-600">
              {t("contact.followSubtitle")}
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-2">
              {artistUser.links.slice(0, 4).map(({ URL, label }) => (
                <a
                  key={label}
                  href={URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t(`links.labels.${label}`)}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-canvas-100 text-canvas-600 transition-colors hover:bg-canvas-900 hover:text-white"
                >
                  <LinkIcon label={label} className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
